import { CacheAPI } from '@business/api/cache';
import { CommonService } from '@business/services';
import { FormSelect } from '@core/components/form';
import { FormControl } from '@core/utils/form';
import { R } from '@core/utils/r';
import { useLazyEffect } from '@core/utils/react';
import React, { memo, useEffect, useMemo, useState } from 'react';
import { tap } from 'rxjs/operators';

export interface ShippingMethodControlProps {
  control: FormControl;
}

export const ShippingMethodControl = memo((props: ShippingMethodControlProps) => {
  const { control } = props;
  const storageKey = useMemo(() => `timeMaterialsShippingMethods`, []);
  const [shippingMethods, setShippingMethods] = useState<string[]>([]);
  const shippingItems = useMemo(() => CommonService.selectItems(shippingMethods, s => s), [shippingMethods]);

  useEffect(() => {
    CacheAPI.get<string>(storageKey)
      .pipe(tap(value => setShippingMethods(R.split(value, ',').filter(s => s != 'null'))))
      .subscribe();
  }, [setShippingMethods, storageKey]);

  useLazyEffect(
    () => {
      if (shippingMethods.length > 0) {
        CacheAPI.put(storageKey, shippingMethods).subscribe();
      }
    },
    [shippingMethods],
    2000,
  );

  return (
    <>
      <FormSelect
        control={control}
        items={shippingItems}
        onAdd={value => {
          setShippingMethods([...shippingMethods, value]);
          control.setValue(value);
        }}
      />
    </>
  );
});
